import { j as y } from "./jsx-runtime-DmTjM30f.mjs";
import { useRef as ue, useLayoutEffect as pe, forwardRef as tt, useState as re, useCallback as z, useMemo as F, createElement as nt, useImperativeHandle as at, useEffect as le, memo as me } from "react";
import { t as rt } from "./throttle-CbOTDqvg.mjs";
import { c as $ } from "./tw-cn-mXgPecoF.mjs";
import { u as st } from "./use-isomorphic-layout-effect-m4WLzKHG.mjs";
import { I as it, a as ot } from "./ic_arrowforward_fill-DIQoCdSY.mjs";
import { I as Oe } from "./icon-button-DImUgRzQ.mjs";
const ye = {}, ae = {};
function se(t, e) {
  try {
    const a = (ye[t] || (ye[t] = new Intl.DateTimeFormat("en-GB", {
      timeZone: t,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(e).split("GMT")[1] || "";
    return a in ae ? ae[a] : ve(a, a.split(":"));
  } catch {
    if (t in ae) return ae[t];
    const n = t == null ? void 0 : t.match(ct);
    return n ? ve(t, n.slice(1)) : NaN;
  }
}
const ct = /([+-]\d\d):?(\d\d)?/;
function ve(t, e) {
  const n = +e[0], a = +(e[1] || 0);
  return ae[t] = n > 0 ? n * 60 + a : n * 60 - a;
}
class L extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(se(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), Ie(this), Te(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new L(...n, e) : new L(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new L(+this, e);
  }
  getTimezoneOffset() {
    return -se(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), Te(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new L(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Pe = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!Pe.test(t)) return;
  const e = t.replace(Pe, "$1UTC");
  L.prototype[e] && (t.startsWith("get") ? L.prototype[t] = function() {
    return this.internal[e]();
  } : (L.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), ut(this), +this;
  }, L.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), Te(this), +this;
  }));
});
function Te(t) {
  t.internal.setTime(+t), t.internal.setUTCMinutes(t.internal.getUTCMinutes() - t.getTimezoneOffset());
}
function ut(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), Ie(t);
}
function Ie(t) {
  const e = se(t.timeZone, t), n = /* @__PURE__ */ new Date(+t);
  n.setUTCHours(n.getUTCHours() - 1);
  const a = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), r = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), i = a - r, c = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  i && c && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + i);
  const s = a - e;
  s && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + s);
  const d = se(t.timeZone, t), l = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - d, u = d !== e, h = l - s;
  if (u && h) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + h);
    const f = se(t.timeZone, t), m = d - f;
    m && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + m), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + m));
  }
}
class X extends L {
  //#region static
  static tz(e, ...n) {
    return n.length ? new X(...n, e) : new X(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, a] = this.tzComponents(), r = `${e}${n}:${a}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, a, r] = this.internal.toUTCString().split(" ");
    return `${e == null ? void 0 : e.slice(0, -1)} ${a} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, a, r] = this.tzComponents();
    return `${e} GMT${n}${a}${r} (${lt(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", a = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, a, r];
  }
  //#endregion
  withTimeZone(e) {
    return new X(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new X(+new Date(e), this.timeZone);
  }
  //#endregion
}
function lt(t, e) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: t,
    timeZoneName: "long"
  }).format(e).slice(12);
}
const He = 6048e5, dt = 864e5, Le = 6e4, _e = 36e5, Ne = Symbol.for("constructDateFrom");
function E(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Ne in t ? t[Ne](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function N(t, e) {
  return E(e || t, t);
}
function Q(t, e, n) {
  const a = N(t, n == null ? void 0 : n.in);
  return isNaN(e) ? E(t, NaN) : (e && a.setDate(a.getDate() + e), a);
}
function ft(t, e, n) {
  const a = N(t, n == null ? void 0 : n.in);
  if (isNaN(e)) return E(t, NaN);
  if (!e)
    return a;
  const r = a.getDate(), i = E(t, a.getTime());
  i.setMonth(a.getMonth() + e + 1, 0);
  const c = i.getDate();
  return r >= c ? i : (a.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), a);
}
let mt = {};
function he() {
  return mt;
}
function oe(t, e) {
  var s, d, o, l;
  const n = he(), a = (e == null ? void 0 : e.weekStartsOn) ?? ((d = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((l = (o = n.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? 0, r = N(t, e == null ? void 0 : e.in), i = r.getDay(), c = (i < a ? 7 : 0) + i - a;
  return r.setDate(r.getDate() - c), r.setHours(0, 0, 0, 0), r;
}
function de(t, e) {
  return oe(t, { ...e, weekStartsOn: 1 });
}
function Ue(t, e) {
  const n = N(t, e == null ? void 0 : e.in), a = n.getFullYear(), r = E(n, 0);
  r.setFullYear(a + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = de(r), c = E(n, 0);
  c.setFullYear(a, 0, 4), c.setHours(0, 0, 0, 0);
  const s = de(c);
  return n.getTime() >= i.getTime() ? a + 1 : n.getTime() >= s.getTime() ? a : a - 1;
}
function ke(t) {
  const e = N(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function xe(t, ...e) {
  const n = E.bind(
    null,
    e.find((a) => typeof a == "object")
  );
  return e.map(n);
}
function fe(t, e) {
  const n = N(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Se(t, e, n) {
  const [a, r] = xe(
    n == null ? void 0 : n.in,
    t,
    e
  ), i = fe(a), c = fe(r), s = +i - ke(i), d = +c - ke(c);
  return Math.round((s - d) / dt);
}
function ht(t, e) {
  const n = Ue(t, e), a = E(t, 0);
  return a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0), de(a);
}
function V(t, e, n) {
  const [a, r] = xe(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return +fe(a) == +fe(r);
}
function gt(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function yt(t) {
  return !(!gt(t) && typeof t != "number" || isNaN(+N(t)));
}
function wt(t, e, n) {
  const [a, r] = xe(
    n == null ? void 0 : n.in,
    t,
    e
  ), i = a.getFullYear() - r.getFullYear(), c = a.getMonth() - r.getMonth();
  return i * 12 + c;
}
function bt(t, e) {
  const n = N(t, e == null ? void 0 : e.in), a = n.getMonth();
  return n.setFullYear(n.getFullYear(), a + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function we(t, e) {
  const n = N(t, e == null ? void 0 : e.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Dt(t, e) {
  const n = N(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Tt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, St = (t, e, n) => {
  let a;
  const r = Tt[t];
  return typeof r == "string" ? a = r : e === 1 ? a = r.one : a = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function J(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const xt = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Mt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ot = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vt = {
  date: J({
    formats: xt,
    defaultWidth: "full"
  }),
  time: J({
    formats: Mt,
    defaultWidth: "full"
  }),
  dateTime: J({
    formats: Ot,
    defaultWidth: "full"
  })
}, Pt = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Nt = (t, e, n, a) => Pt[t];
function I(t) {
  return (e, n) => {
    const a = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (a === "formatting" && t.formattingValues) {
      const c = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : c;
      r = t.formattingValues[s] || t.formattingValues[c];
    } else {
      const c = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      r = t.values[s] || t.values[c];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[i];
  };
}
const kt = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ct = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Wt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Yt = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, jt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ft = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Et = (t, e) => {
  const n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, $t = {
  ordinalNumber: Et,
  era: I({
    values: kt,
    defaultWidth: "wide"
  }),
  quarter: I({
    values: Ct,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: I({
    values: Wt,
    defaultWidth: "wide"
  }),
  day: I({
    values: Yt,
    defaultWidth: "wide"
  }),
  dayPeriod: I({
    values: jt,
    defaultWidth: "wide",
    formattingValues: Ft,
    defaultFormattingWidth: "wide"
  })
};
function H(t) {
  return (e, n = {}) => {
    const a = n.width, r = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], i = e.match(r);
    if (!i)
      return null;
    const c = i[0], s = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], d = Array.isArray(s) ? It(s, (u) => u.test(c)) : (
      // [TODO] -- I challenge you to fix the type
      pt(s, (u) => u.test(c))
    );
    let o;
    o = t.valueCallback ? t.valueCallback(d) : d, o = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(o)
    ) : o;
    const l = e.slice(c.length);
    return { value: o, rest: l };
  };
}
function pt(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function It(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Ae(t) {
  return (e, n = {}) => {
    const a = e.match(t.matchPattern);
    if (!a) return null;
    const r = a[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let c = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    c = n.valueCallback ? n.valueCallback(c) : c;
    const s = e.slice(r.length);
    return { value: c, rest: s };
  };
}
const Ht = /^(\d+)(th|st|nd|rd)?/i, Lt = /\d+/i, _t = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ut = {
  any: [/^b/i, /^(a|c)/i]
}, At = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Rt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, zt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, qt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Bt = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Vt = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Xt = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Qt = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Gt = {
  ordinalNumber: Ae({
    matchPattern: Ht,
    parsePattern: Lt,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: H({
    matchPatterns: _t,
    defaultMatchWidth: "wide",
    parsePatterns: Ut,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: At,
    defaultMatchWidth: "wide",
    parsePatterns: Rt,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: H({
    matchPatterns: zt,
    defaultMatchWidth: "wide",
    parsePatterns: qt,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: Bt,
    defaultMatchWidth: "wide",
    parsePatterns: Vt,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: Xt,
    defaultMatchWidth: "any",
    parsePatterns: Qt,
    defaultParseWidth: "any"
  })
}, Zt = {
  code: "en-US",
  formatDistance: St,
  formatLong: vt,
  formatRelative: Nt,
  localize: $t,
  match: Gt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Jt(t, e) {
  const n = N(t, e == null ? void 0 : e.in);
  return Se(n, Dt(n)) + 1;
}
function Kt(t, e) {
  const n = N(t, e == null ? void 0 : e.in), a = +de(n) - +ht(n);
  return Math.round(a / He) + 1;
}
function Re(t, e) {
  var l, u, h, f;
  const n = N(t, e == null ? void 0 : e.in), a = n.getFullYear(), r = he(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((u = (l = e == null ? void 0 : e.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((f = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, c = E((e == null ? void 0 : e.in) || t, 0);
  c.setFullYear(a + 1, 0, i), c.setHours(0, 0, 0, 0);
  const s = oe(c, e), d = E((e == null ? void 0 : e.in) || t, 0);
  d.setFullYear(a, 0, i), d.setHours(0, 0, 0, 0);
  const o = oe(d, e);
  return +n >= +s ? a + 1 : +n >= +o ? a : a - 1;
}
function en(t, e) {
  var s, d, o, l;
  const n = he(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((l = (o = n.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, r = Re(t, e), i = E((e == null ? void 0 : e.in) || t, 0);
  return i.setFullYear(r, 0, a), i.setHours(0, 0, 0, 0), oe(i, e);
}
function tn(t, e) {
  const n = N(t, e == null ? void 0 : e.in), a = +oe(n, e) - +en(n, e);
  return Math.round(a / He) + 1;
}
function S(t, e) {
  const n = t < 0 ? "-" : "", a = Math.abs(t).toString().padStart(e, "0");
  return n + a;
}
const R = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), a = n > 0 ? n : 1 - n;
    return S(e === "yy" ? a % 100 : a, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : S(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return S(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return S(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return S(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return S(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return S(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, a = t.getMilliseconds(), r = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return S(r, e.length);
  }
}, Z = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ce = {
  // Era
  G: function(t, e, n) {
    const a = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const a = t.getFullYear(), r = a > 0 ? a : 1 - a;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return R.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, a) {
    const r = Re(t, a), i = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const c = i % 100;
      return S(c, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : S(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = Ue(t);
    return S(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return S(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(a);
      case "QQ":
        return S(a, 2);
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(a);
      case "qq":
        return S(a, 2);
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return R.M(t, e);
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "L":
        return String(a + 1);
      case "LL":
        return S(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, a) {
    const r = tn(t, a);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : S(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const a = Kt(t);
    return e === "Io" ? n.ordinalNumber(a, { unit: "week" }) : S(a, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : R.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const a = Jt(t);
    return e === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : S(a, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const a = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, a) {
    const r = t.getDay(), i = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(i);
      case "ee":
        return S(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, a) {
    const r = t.getDay(), i = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(i);
      case "cc":
        return S(i, e.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const a = t.getDay(), r = a === 0 ? 7 : a;
    switch (e) {
      case "i":
        return String(r);
      case "ii":
        return S(r, e.length);
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const a = t.getHours();
    let r;
    switch (a === 12 ? r = Z.noon : a === 0 ? r = Z.midnight : r = a / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const a = t.getHours();
    let r;
    switch (a >= 17 ? r = Z.evening : a >= 12 ? r = Z.afternoon : a >= 4 ? r = Z.morning : r = Z.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let a = t.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return R.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : R.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const a = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : S(a, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let a = t.getHours();
    return a === 0 && (a = 24), e === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : S(a, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : R.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : R.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return R.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const a = t.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return Ye(a);
      case "XXXX":
      case "XX":
        return B(a);
      case "XXXXX":
      case "XXX":
      default:
        return B(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return Ye(a);
      case "xxxx":
      case "xx":
        return B(a);
      case "xxxxx":
      case "xxx":
      default:
        return B(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + We(a, ":");
      case "OOOO":
      default:
        return "GMT" + B(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + We(a, ":");
      case "zzzz":
      default:
        return "GMT" + B(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const a = Math.trunc(+t / 1e3);
    return S(a, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return S(+t, e.length);
  }
};
function We(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), r = Math.trunc(a / 60), i = a % 60;
  return i === 0 ? n + String(r) : n + String(r) + e + S(i, 2);
}
function Ye(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + S(Math.abs(t) / 60, 2) : B(t, e);
}
function B(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), r = S(Math.trunc(a / 60), 2), i = S(a % 60, 2);
  return n + r + e + i;
}
const je = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, ze = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, nn = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], a = n[1], r = n[2];
  if (!r)
    return je(t, e);
  let i;
  switch (a) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", je(a, e)).replace("{{time}}", ze(r, e));
}, an = {
  p: ze,
  P: nn
}, rn = /^D+$/, sn = /^Y+$/, on = ["D", "DD", "YY", "YYYY"];
function cn(t) {
  return rn.test(t);
}
function un(t) {
  return sn.test(t);
}
function ln(t, e, n) {
  const a = dn(t, e, n);
  if (console.warn(a), on.includes(t)) throw new RangeError(a);
}
function dn(t, e, n) {
  const a = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const fn = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, mn = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, hn = /^'([^]*?)'?$/, gn = /''/g, yn = /[a-zA-Z]/;
function K(t, e, n) {
  var l, u, h, f, m, g, M, W;
  const a = he(), r = (n == null ? void 0 : n.locale) ?? a.locale ?? Zt, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (l = n == null ? void 0 : n.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((f = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, c = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) ?? a.weekStartsOn ?? ((W = (M = a.locale) == null ? void 0 : M.options) == null ? void 0 : W.weekStartsOn) ?? 0, s = N(t, n == null ? void 0 : n.in);
  if (!yt(s))
    throw new RangeError("Invalid time value");
  let d = e.match(mn).map((w) => {
    const O = w[0];
    if (O === "p" || O === "P") {
      const k = an[O];
      return k(w, r.formatLong);
    }
    return w;
  }).join("").match(fn).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const O = w[0];
    if (O === "'")
      return { isToken: !1, value: wn(w) };
    if (Ce[O])
      return { isToken: !0, value: w };
    if (O.match(yn))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + O + "`"
      );
    return { isToken: !1, value: w };
  });
  r.localize.preprocessor && (d = r.localize.preprocessor(s, d));
  const o = {
    firstWeekContainsDate: i,
    weekStartsOn: c,
    locale: r
  };
  return d.map((w) => {
    if (!w.isToken) return w.value;
    const O = w.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && un(O) || !(n != null && n.useAdditionalDayOfYearTokens) && cn(O)) && ln(O, e, String(t));
    const k = Ce[O[0]];
    return k(s, O, r.localize, o);
  }).join("");
}
function wn(t) {
  const e = t.match(hn);
  return e ? e[1].replace(gn, "'") : t;
}
function be(t, e) {
  return +N(t) > +N(e);
}
function ie(t, e) {
  return +N(t) < +N(e);
}
function Fe(t, e) {
  return +N(t) == +N(e);
}
function bn(t, e, n) {
  return Q(t, -e, n);
}
function qe(t, e) {
  const n = () => E(e == null ? void 0 : e.in, NaN), r = xn(t);
  let i;
  if (r.date) {
    const o = Mn(r.date, 2);
    i = On(o.restDateString, o.year);
  }
  if (!i || isNaN(+i)) return n();
  const c = +i;
  let s = 0, d;
  if (r.time && (s = vn(r.time), isNaN(s)))
    return n();
  if (r.timezone) {
    if (d = Pn(r.timezone), isNaN(d)) return n();
  } else {
    const o = new Date(c + s), l = N(0, e == null ? void 0 : e.in);
    return l.setFullYear(
      o.getUTCFullYear(),
      o.getUTCMonth(),
      o.getUTCDate()
    ), l.setHours(
      o.getUTCHours(),
      o.getUTCMinutes(),
      o.getUTCSeconds(),
      o.getUTCMilliseconds()
    ), l;
  }
  return N(c + s + d, e == null ? void 0 : e.in);
}
const ce = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Dn = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Tn = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Sn = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function xn(t) {
  const e = {}, n = t.split(ce.dateTimeDelimiter);
  let a;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? a = n[0] : (e.date = n[0], a = n[1], ce.timeZoneDelimiter.test(e.date) && (e.date = t.split(ce.timeZoneDelimiter)[0], a = t.substr(
    e.date.length,
    t.length
  ))), a) {
    const r = ce.timezone.exec(a);
    r ? (e.time = a.replace(r[1], ""), e.timezone = r[1]) : e.time = a;
  }
  return e;
}
function Mn(t, e) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), a = t.match(n);
  if (!a) return { year: NaN, restDateString: "" };
  const r = a[1] ? parseInt(a[1]) : null, i = a[2] ? parseInt(a[2]) : null;
  return {
    year: i === null ? r : i * 100,
    restDateString: t.slice((a[1] || a[2]).length)
  };
}
function On(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const n = t.match(Dn);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const a = !!n[4], r = ne(n[1]), i = ne(n[2]) - 1, c = ne(n[3]), s = ne(n[4]), d = ne(n[5]) - 1;
  if (a)
    return Yn(e, s, d) ? Nn(e, s, d) : /* @__PURE__ */ new Date(NaN);
  {
    const o = /* @__PURE__ */ new Date(0);
    return !Cn(e, i, c) || !Wn(e, r) ? /* @__PURE__ */ new Date(NaN) : (o.setUTCFullYear(e, i, Math.max(r, c)), o);
  }
}
function ne(t) {
  return t ? parseInt(t) : 1;
}
function vn(t) {
  const e = t.match(Tn);
  if (!e) return NaN;
  const n = De(e[1]), a = De(e[2]), r = De(e[3]);
  return jn(n, a, r) ? n * _e + a * Le + r * 1e3 : NaN;
}
function De(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function Pn(t) {
  if (t === "Z") return 0;
  const e = t.match(Sn);
  if (!e) return 0;
  const n = e[1] === "+" ? -1 : 1, a = parseInt(e[2]), r = e[3] && parseInt(e[3]) || 0;
  return Fn(a, r) ? n * (a * _e + r * Le) : NaN;
}
function Nn(t, e, n) {
  const a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4);
  const r = a.getUTCDay() || 7, i = (e - 1) * 7 + n + 1 - r;
  return a.setUTCDate(a.getUTCDate() + i), a;
}
const kn = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Be(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Cn(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (kn[e] || (Be(t) ? 29 : 28));
}
function Wn(t, e) {
  return e >= 1 && e <= (Be(t) ? 366 : 365);
}
function Yn(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function jn(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function Fn(t, e) {
  return e >= 0 && e <= 59;
}
const Ve = (t) => {
  const e = ue(null);
  return pe(() => {
    var a, r;
    if (t.height !== null && t.height !== void 0)
      return;
    const n = (a = e.current) == null ? void 0 : a.getBoundingClientRect().height;
    n && ((r = t.updateHeight) == null || r.call(t, n, t.index));
  }, [t]), /* @__PURE__ */ y.jsx(
    "div",
    {
      className: `absolute w-full ${t.isVisible ? "visible" : "invisible"}`,
      ref: e,
      style: { top: `${t.offsetTop}px` },
      children: t.render()
    }
  );
};
Ve.displayName = "NDS.VirtualListItem";
const Xe = tt(
  ({
    items: t,
    listHeight: e,
    updateHeight: n,
    preLoadingThreshold: a = 50,
    updateInterval: r = 80,
    scrollRef: i,
    footer: c,
    header: s,
    className: d,
    ...o
  }, l) => {
    const [u, h] = re([]), f = ue(), [m, g] = re(0), [M, W] = re(e || 0), w = ue(null), O = z(
      (() => {
        const b = rt(g, r, {
          leading: !0,
          trailing: !0
        });
        return (D) => {
          const T = D.currentTarget.scrollTop;
          b(T);
        };
      })(),
      [r]
    ), k = F(() => {
      if (u.length === 0)
        return;
      const b = a, D = Math.max(
        0,
        u.findIndex((x) => x >= m - b)
      ), T = u.findIndex((x) => x >= m + M + b, D), Y = t.slice(D, T < 0 ? t.length : T), _ = u.slice(D, T < 0 ? t.length : T), G = u.length === 1 || u.length > 1 && u.some((x) => x !== 0);
      return Y.map((x, P) => /* @__PURE__ */ nt(
        Ve,
        {
          ...x,
          index: D + P,
          isVisible: G,
          key: P,
          offsetTop: _[P],
          updateHeight: n
        },
        x.render()
      ));
    }, [t, u, m, M, n, a]);
    return at(
      i,
      () => ({
        scrollByItemIndex: async (b, D = 0) => {
          await new Promise((T) => {
            setTimeout(() => {
              T();
            }, 0);
          }), w.current && f.current && (w.current.scrollTop = f.current[b] + D);
        }
      }),
      [u]
    ), pe(() => {
      const b = t.reduce(
        (D, T) => (D.currentOffset += T.height || 0, D.offsetList.push(D.currentOffset), D),
        { currentOffset: 0, offsetList: [0] }
      );
      h(b.offsetList), f.current = b.offsetList;
    }, [t]), le(() => {
      const b = () => {
        var D;
        W(((D = w.current) == null ? void 0 : D.getBoundingClientRect().height) || 0);
      };
      return b(), window.addEventListener("resize", b), () => {
        window.removeEventListener("resize", b);
      };
    }, []), /* @__PURE__ */ y.jsxs(
      "div",
      {
        ...o,
        className: $("relative size-full overflow-y-auto", d),
        onScroll: (b) => {
          var D;
          (D = o.onScroll) == null || D.call(o, b), O(b);
        },
        ref: (b) => {
          b && (w.current = b, l && typeof l != "string" && "current" in l && (l.current = b));
        },
        children: [
          s,
          /* @__PURE__ */ y.jsx("div", { style: { height: `${e}px`, width: "100%" }, children: k }),
          c
        ]
      }
    );
  }
);
Xe.displayName = "NDS.VirtualList";
const En = ["일", "월", "화", "수", "목", "금", "토"], Qe = ({ deviceType: t, className: e }) => {
  const n = t === "etc";
  return /* @__PURE__ */ y.jsx("div", { className: $("grid min-h-32 grid-cols-7 text-text-neutral-main", e), children: En.map((a, r) => /* @__PURE__ */ y.jsx(
    "div",
    {
      className: $("px-18 py-6 text-center", n ? "typography-body-14-regular" : "typography-body-13-regular"),
      children: a
    },
    `${a}_${r}`
  )) });
};
Qe.displayName = "NDS.DayPickerWeeks";
const $n = ({ type: t, className: e }) => /* @__PURE__ */ y.jsx(y.Fragment, { children: t === "start" ? /* @__PURE__ */ y.jsx(
  "svg",
  {
    className: e,
    fill: "none",
    height: "36",
    viewBox: "0 0 40 36",
    width: "40",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ y.jsx(
      "path",
      {
        d: "M0 8C0 3.58172 3.58172 0 8 0H25.7782C28.8039 0 31.5707 1.70699 32.928 4.41112L40 18.5L32.9691 31.7499C31.5814 34.365 28.8629 36 25.9024 36H8C3.58172 36 0 32.4183 0 28V8Z",
        fill: "#1B1C1F"
      }
    )
  }
) : /* @__PURE__ */ y.jsx(
  "svg",
  {
    className: e,
    fill: "none",
    height: "36",
    viewBox: "0 0 40 36",
    width: "40",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ y.jsx(
      "path",
      {
        d: "M40 8C40 3.58172 36.4183 0 32 0H14.2218C11.1961 0 8.42931 1.70699 7.07196 4.41112L0 18.5L7.03086 31.7499C8.41856 34.365 11.1371 36 14.0976 36H32C36.4183 36 40 32.4183 40 28V8Z",
        fill: "#1B1C1F",
        id: "Selected"
      }
    )
  }
) }), Ge = (t) => {
  const { day: e, isPc: n, className: a, dayDescriptions: r, onSelectDate: i } = t, { date: c, dateType: s, dateObject: d, isSelected: o, isFirstSelected: l, isLastSelected: u, isToday: h, disabled: f } = e, m = F(() => s === "sunday" || s === "holiday", [s]), g = F(() => s === "empty", [s]), M = F(() => g ? "" : l && (r != null && r[0]) ? r[0] : u && (r != null && r[1]) ? r[1] : e.text, [g, l, r, u, e.text]), W = z(() => {
    i == null || i(d);
  }, [d, i]);
  return /* @__PURE__ */ y.jsxs(
    "div",
    {
      className: "relative flex w-full min-w-40 flex-col items-center justify-center",
      "data-datetype": s,
      "data-day": d ? K(d, "yyyy-MM-dd") : void 0,
      "data-disabled": f || void 0,
      "data-month": d ? K(d, "yyyy-MM") : void 0,
      "data-selected": o || void 0,
      "data-today": h,
      children: [
        /* @__PURE__ */ y.jsx(
          "div",
          {
            className: $("absolute left-0 right-0 top-0 h-36 w-full", {
              "bg-fill-neutral-weak1": o && !(l && u),
              "left-auto w-1/2": !g && l,
              "right-auto w-1/2": !g && u
            })
          }
        ),
        /* @__PURE__ */ y.jsxs(
          "button",
          {
            className: $(
              "relative flex h-36 w-36 items-center justify-center rounded-full text-text-neutral-main typography-subtitle-16-bold",
              n ? "typography-subtitle-18-bold" : "typography-subtitle-16-bold",
              {
                invisible: g
              },
              {
                // TODO: sunday와 holiday 색상 확인 필요
                "!text-text-danger-main": m,
                "bg-background": o,
                "!text-static-white": l || u,
                "!cursor-not-allowed !opacity-30": f && !o,
                "cursor-pointer rounded-full border-2 border-solid border-line-neutral-weak2 bg-transparent opacity-100": !l && !u && !o && h
              },
              a
            ),
            disabled: f,
            onClick: W,
            type: "button",
            children: [
              /* @__PURE__ */ y.jsx("span", { className: "z-20", children: c }),
              l || u ? /* @__PURE__ */ y.jsx(
                $n,
                {
                  className: $("absolute top-0 h-36 w-40", l ? "-left-1" : "-right-1"),
                  type: l ? "start" : "end"
                }
              ) : null
            ]
          }
        ),
        /* @__PURE__ */ y.jsx("span", { className: "flex h-15 flex-col items-center justify-center pt-2 text-text-neutral-sub typography-caption-11-regular", children: M })
      ]
    }
  );
};
Ge.displayName = "NDS.CalendarDay";
const pn = me(Ge), Me = (t) => {
  const { id: e, month: n, days: a, year: r, dayDescriptions: i, isPc: c, showWeeks: s, className: d, styles: o, onSelectDate: l } = t, u = n.toString().padStart(2, "0"), h = F(
    () => Array.from({ length: a.length / 7 }, (f, m) => a.slice(m * 7, (m + 1) * 7)),
    [a]
  );
  return /* @__PURE__ */ y.jsxs("div", { className: $("w-full", d), id: e, style: o, children: [
    /* @__PURE__ */ y.jsx("div", { className: "relative flex items-center justify-center pt-1", children: /* @__PURE__ */ y.jsxs("span", { className: $(c ? "py-16 typography-subtitle-18-bold" : "py-12 typography-subtitle-16-bold"), children: [
      r,
      ".",
      u
    ] }) }),
    !!s && /* @__PURE__ */ y.jsx(Qe, { className: "mb-4" }),
    /* @__PURE__ */ y.jsx("div", { className: "flex w-full min-w-[280px] flex-col gap-6", role: "grid", children: h.map((f, m) => /* @__PURE__ */ y.jsx("div", { className: "grid w-full grid-cols-7 gap-0", children: f.map((g, M) => /* @__PURE__ */ y.jsx(
      pn,
      {
        className: g.className,
        day: g,
        dayDescriptions: i,
        isPc: c,
        onSelectDate: l
      },
      `${r}-${n}-${M}`
    )) }, `${r}-${n}-${m}`)) })
  ] });
};
Me.displayName = "NDS.CalendarMonth";
const In = me(Me), Hn = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, Ln = (t, e, n) => {
  let a;
  const r = Hn[t];
  return typeof r == "string" ? a = r : e === 1 ? a = r.one : a = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? a + " 후" : a + " 전" : a;
}, _n = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, Un = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, An = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Rn = {
  date: J({
    formats: _n,
    defaultWidth: "full"
  }),
  time: J({
    formats: Un,
    defaultWidth: "full"
  }),
  dateTime: J({
    formats: An,
    defaultWidth: "full"
  })
}, zn = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, qn = (t, e, n, a) => zn[t], Bn = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, Vn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, Xn = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ],
  wide: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ]
}, Qn = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, Gn = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, Zn = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, Jn = (t, e) => {
  const n = Number(t);
  switch (String(e == null ? void 0 : e.unit)) {
    case "minute":
    case "second":
      return String(n);
    case "date":
      return n + "일";
    default:
      return n + "번째";
  }
}, Kn = {
  ordinalNumber: Jn,
  era: I({
    values: Bn,
    defaultWidth: "wide"
  }),
  quarter: I({
    values: Vn,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: I({
    values: Xn,
    defaultWidth: "wide"
  }),
  day: I({
    values: Qn,
    defaultWidth: "wide"
  }),
  dayPeriod: I({
    values: Gn,
    defaultWidth: "wide",
    formattingValues: Zn,
    defaultFormattingWidth: "wide"
  })
}, ea = /^(\d+)(일|번째)?/i, ta = /\d+/i, na = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, aa = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, ra = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, sa = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ia = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, oa = {
  any: [
    /^1월?$/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, ca = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, ua = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, la = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, da = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, fa = {
  ordinalNumber: Ae({
    matchPattern: ea,
    parsePattern: ta,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: H({
    matchPatterns: na,
    defaultMatchWidth: "wide",
    parsePatterns: aa,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: ra,
    defaultMatchWidth: "wide",
    parsePatterns: sa,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: H({
    matchPatterns: ia,
    defaultMatchWidth: "wide",
    parsePatterns: oa,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: ca,
    defaultMatchWidth: "wide",
    parsePatterns: ua,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: la,
    defaultMatchWidth: "any",
    parsePatterns: da,
    defaultParseWidth: "any"
  })
}, Ee = {
  code: "ko",
  formatDistance: Ln,
  formatLong: Rn,
  formatRelative: qn,
  localize: Kn,
  match: fa,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, ma = 365, ha = 1, ga = "지금부터", Ze = (t) => {
  const e = F(() => {
    var u;
    const [c, s] = [we(t.from), we(t.to)], d = wt(s, c) + 1, o = Array.from({ length: d }, (h, f) => ft(c, f)), l = (u = t.holidays) == null ? void 0 : u.reduce(
      (h, f) => (h[f.toDateString()] = f, h),
      {}
    );
    return o.map((h) => {
      const f = we(h), m = bt(h), g = Se(m, f) + 1, M = (T) => {
        const Y = T.getDay(), _ = l != null && l[T.toDateString()] ? "holiday" : (() => {
          switch (Y) {
            case 0:
              return "sunday";
            case 6:
              return "saturday";
            default:
              return "weekday";
          }
        })();
        return {
          date: T.getDate(),
          dateType: _,
          dateObject: T
        };
      }, W = Array.from({ length: g }, (T, Y) => Q(f, Y)).map(
        M
      ), w = W[0], O = [];
      for (let T = f.getDay(); T > 0 && w.dateObject; T--) {
        const Y = Q(w.dateObject, -T), _ = T === 1 ? { ...w, date: Y.getDate(), dateObject: Y } : {};
        O.push({
          ..._,
          dateType: "empty"
        });
      }
      const k = [...O, ...W], b = 7 - k.length % 7, D = k[k.length - 1];
      if (b > 0 && b < 7)
        for (let T = 0; T < b; T++) {
          const Y = T === 0 ? D : {};
          k.push({
            ...Y,
            dateType: "empty"
          });
        }
      return {
        year: f.getFullYear(),
        month: f.getMonth() + 1,
        weekCount: Math.ceil(k.length / 7),
        days: k
      };
    });
  }, [t.from.toISOString(), t.to.toISOString(), t.holidays]), n = z(
    (c) => t.calendarType === "fromPastToNow" ? (s) => ie(s, c) || Fe(s, c) : t.calendarType === "fromNowToFuture" ? (s) => be(s, c) || Fe(s, c) : () => !0,
    [t.calendarType]
  ), a = F(() => {
    const c = t.today, s = n(c.getTime());
    return e.map((d) => {
      const o = d.days.map((l) => {
        const u = { ...l };
        if (u.dateType === "empty" || !u.dateObject)
          return u;
        const h = V(u.dateObject, c), f = s(u.dateObject.getTime()), m = ie(u.dateObject, t.from) && !h, g = be(u.dateObject, t.to);
        return u.disabled = !!u.disabled || m || g || !h && !f, t.useYanoljaTime && V(u.dateObject, bn(c, 1)) && (u.text = ga, u.disabled = !1), h && (u.isToday = !0), u;
      });
      return {
        ...d,
        days: o
      };
    });
  }, [t.from.toISOString(), t.to.toISOString(), t.useYanoljaTime, e]), r = F(() => {
    if (!t.selectedDate) return a;
    const [c, s] = t.selectedDate, d = !!c && K(c, "MM", { locale: Ee }), o = !!s && K(s, "MM", { locale: Ee });
    return c && !s ? a.map((l) => {
      const u = (m) => Se(m, c), h = (m) => {
        const g = u(m);
        return g < 0 ? !0 : g < (t.minDuration ?? ha) ? !1 : g <= (t.maxDuration ?? ma);
      }, f = l.days.map((m) => {
        const g = { ...m };
        return g.dateType === "empty" || g.disabled || !g.dateObject || (g.disabled = !h(g.dateObject), V(c, g.dateObject) && (g.isFirstSelected = !0, g.isLastSelected = !0, g.isSelected = !0)), g;
      });
      return {
        ...l,
        days: f
      };
    }) : c && s ? a.map((l) => {
      const u = l.days.map((h) => {
        const f = { ...h }, m = f.dateObject;
        return m && (f.isSelected = ie(m, s) && be(m, c), f.isFirstSelected = V(c, m), f.isLastSelected = f.dateType !== "empty" && V(s, m), (f.isFirstSelected || f.isLastSelected) && (f.isSelected = !0), f.dateType === "empty" && d === o && (f.isFirstSelected = !1, f.isLastSelected = !1, f.isSelected = !1)), f;
      });
      return {
        ...l,
        days: u
      };
    }) : a;
  }, [a, t.selectedDate, t.maxDuration, t.minDuration]);
  return {
    calendar: F(
      () => t.adjustCalendar ? t.adjustCalendar(r) : r,
      [t.adjustCalendar, r]
    )
  };
}, ya = 179, wa = 44, $e = 51, ba = 6, Da = 16, Ta = 10, Je = (t) => {
  const {
    deviceType: e,
    type: n = "range",
    calendarType: a = "fromNowToFuture",
    selectedDate: r,
    holidays: i,
    header: c,
    headerHeight: s = Ta,
    footer: d,
    options: o,
    className: l,
    monthClassName: u,
    onDateChange: h
  } = t, f = e === "etc", m = F(
    () => qe(K((o == null ? void 0 : o.today) ?? X.tz("Asia/Seoul"), "yyyy-MM-dd")),
    [o == null ? void 0 : o.today]
  ), g = [m, Q(m, 1)], M = r ?? g, W = ue(null), [w, O] = re([]), k = F(() => w.reduce((x, { height: P }) => x + (P || 0), 0), [w]), { calendar: b } = Ze({
    from: (o == null ? void 0 : o.from) ?? m,
    to: (o == null ? void 0 : o.to) ?? Q(m, (o == null ? void 0 : o.maxDaysCount) ?? ya),
    selectedDate: r,
    today: m,
    calendarType: a,
    holidays: i,
    useYanoljaTime: !!(o != null && o.useYanoljaTime),
    ...o
  }), D = z(
    (x) => {
      const [P, j] = M;
      if (!x) return;
      const q = P && !j && V(P, x), U = !P || M.every((v) => !!v), A = P && ie(x, P);
      if (q || U || A) {
        const v = [x, void 0];
        h == null || h(v, "startDate");
      } else {
        const v = [P, x];
        h == null || h(v, "endDate");
      }
    },
    [h, M]
  ), T = z(
    (x) => {
      switch (n) {
        case "single":
          Y();
          break;
        case "range":
          D(x);
          break;
        case "both":
          _();
          break;
        default:
          throw new Error("Invalid calendar type");
      }
    },
    [D, n]
  ), Y = (x) => {
  }, _ = (x) => {
  };
  le(() => {
    !(r != null && r[0]) && !(r != null && r[1]) && (h == null || h(g, "initial"));
  }, []);
  const G = z(
    (x, P) => {
      const j = [...w];
      j[P].height = x, O(j);
    },
    [w]
  );
  return st(() => {
    const x = b.map(({ year: P, month: j, days: q, weekCount: U }, A) => {
      const v = A === 0, C = U * $e + // 주 단위 높이
      (U - 1) * ba + wa + // 년월 제목
      Da + // 월간 구분 공백
      (v ? s : 0);
      return {
        render: () => /* @__PURE__ */ y.jsx(
          In,
          {
            className: $("pb-16", u),
            "data-index": A,
            dayDescriptions: o == null ? void 0 : o.dayDescriptions,
            days: q,
            id: `day-picker-${P}-${j.toString().padStart(2, "0")}`,
            isPc: f,
            month: j,
            onSelectDate: T,
            styles: {
              paddingTop: v ? `${s}px` : void 0
            },
            year: P
          },
          `${P}-${j}`
        ),
        height: C
      };
    });
    O(x);
  }, [b, s]), le(() => {
    var C;
    if (!(r != null && r[0])) return;
    const x = r[0].getMonth() + 1, P = b.findIndex((p) => p.month === x);
    if (P === -1) return;
    const j = 1.5, q = r[0].getDate(), { days: U } = b[P], A = U.findIndex((p) => p.dateType !== "empty" && p.date === q), v = Math.max(Math.ceil(A / 7) - j, 0);
    (C = W.current) == null || C.scrollByItemIndex(P, v * $e);
  }, []), /* @__PURE__ */ y.jsx(
    Xe,
    {
      className: l,
      footer: d,
      header: c,
      items: w,
      listHeight: k,
      onScroll: t.onScroll,
      preLoadingThreshold: (o == null ? void 0 : o.preLoadingThreshold) ?? 400,
      scrollRef: W,
      updateHeight: G,
      updateInterval: (o == null ? void 0 : o.updateInterval) ?? 50
    }
  );
};
Je.displayName = "NDS.DayPicker";
me(Je);
const Sa = 179, Ke = (t) => {
  const {
    deviceType: e,
    type: n = "range",
    calendarType: a = "fromNowToFuture",
    selectedDate: r,
    holidays: i,
    footer: c,
    options: s,
    className: d,
    monthClassName: o,
    onChangePage: l,
    onChangeDate: u,
    customLastPageNode: h
  } = t, f = e === "etc", { pageSize: m = 2, adjustCalendar: g } = s ?? {}, [M, W] = re(0), w = F(
    () => qe(K((s == null ? void 0 : s.today) ?? X.tz("Asia/Seoul"), "yyyy-MM-dd")),
    [s == null ? void 0 : s.today]
  ), O = [w, Q(w, 1)], k = r ?? O, { calendar: b } = Ze({
    from: (s == null ? void 0 : s.from) ?? w,
    to: (s == null ? void 0 : s.to) ?? Q(w, (s == null ? void 0 : s.maxDaysCount) ?? Sa),
    selectedDate: r,
    today: w,
    calendarType: a,
    holidays: i,
    useYanoljaTime: !!(s != null && s.useYanoljaTime),
    adjustCalendar: g,
    ...s
  }), D = Math.max(1, b.length - m + 1), T = M === 0, Y = M === D - 1, _ = F(() => h && M === D - 1 ? [...b.slice(M, M + m - 1), "__CUSTOM_LAST_PAGE_NODE__"] : b.slice(M, M + m), [b, M, m, D]), G = (v) => {
    const C = Math.max(0, Math.min(D - 1, v));
    W(C), l == null || l({
      currentPage: C,
      isFirst: C === 0,
      isLast: C === D - 1
    });
  }, x = () => {
    G(M - 1);
  }, P = () => {
    G(M + 1);
  }, j = z(
    (v) => {
      const [C, p] = k;
      if (!v) return;
      const ee = C && !p && V(C, v), ge = !C || k.every((te) => !!te), et = C && ie(v, C);
      if (ee || ge || et) {
        const te = [v, void 0];
        u == null || u(te, "startDate");
      } else {
        const te = [C, v];
        u == null || u(te, "endDate");
      }
    },
    [u, k]
  ), q = z(
    (v) => {
      switch (n) {
        case "single":
          U();
          break;
        case "range":
          j(v);
          break;
        case "both":
          A();
          break;
        default:
          throw new Error("Invalid calendar type");
      }
    },
    [j, n]
  ), U = (v) => {
  }, A = (v) => {
  };
  return le(() => {
    !(r != null && r[0]) && !(r != null && r[1]) && (u == null || u(O, "initial"));
  }, []), /* @__PURE__ */ y.jsxs("div", { className: $("relative", d), children: [
    /* @__PURE__ */ y.jsxs("div", { className: "absolute -top-2 z-10 flex w-full justify-between", children: [
      /* @__PURE__ */ y.jsx(
        Oe,
        {
          "aria-label": "이전 달",
          className: T ? "invisible" : "",
          icon: /* @__PURE__ */ y.jsx(it, {}),
          onClick: x,
          size: "large",
          theme: "ghost"
        }
      ),
      /* @__PURE__ */ y.jsx(
        Oe,
        {
          "aria-label": "다음 달",
          className: Y ? "invisible" : "",
          icon: /* @__PURE__ */ y.jsx(ot, {}),
          onClick: P,
          size: "large",
          theme: "ghost"
        }
      )
    ] }),
    /* @__PURE__ */ y.jsx("div", { className: "flex w-full gap-20 overflow-hidden", children: _.map((v, C) => {
      if (typeof v == "string")
        return /* @__PURE__ */ y.jsx("div", { className: "w-full", children: h }, "last-page-node");
      const { year: p, month: ee, days: ge } = v;
      return /* @__PURE__ */ y.jsx("div", { className: "w-full", children: /* @__PURE__ */ y.jsx(
        Me,
        {
          className: $(o),
          "data-index": C + M * m,
          dayDescriptions: s == null ? void 0 : s.dayDescriptions,
          days: ge,
          id: `day-picker-${p}-${ee.toString().padStart(2, "0")}`,
          isPc: f,
          month: ee,
          onSelectDate: q,
          showWeeks: !0,
          year: p
        }
      ) }, `${p}-${ee}`);
    }) }),
    /* @__PURE__ */ y.jsx("div", { className: "mt-16", children: c })
  ] });
};
Ke.displayName = "NDS.DayPickerPagination";
me(Ke);
export {
  Je as D,
  Ke as a,
  Qe as b,
  Ze as u
};
